import store from "../../../../store/store";
import { chatWithOperator } from "../../../../widgets/reducers/chatWithOperator";
export var prepareChatStore = function prepareChatStore() {
  store.addReducer(chatWithOperator);
};